export default {
  cancelUnpaidCheckout: "Annuler",
  changeSelection: "Modifier ma sélection",
  packIncludesBoost:
    "Comprend le boost de {{count}} jours, qui place votre annonce en tête de sa catégorie.",
  cartHeading: "Vérifiez vos services",
  cartLead: "Tous les services affichés sont inclus dans un seul paiement.",
  existingPayment:
    "Un paiement est en attente. Vérifiez ses éléments d’origine avant de payer à nouveau.",
  resumePackagePayment: "Vérifier le paiement en attente",
  emptyCart: "Aucun service sélectionné.",
  removeItem: "Supprimer",
  currentCart: "Sélection actuelle",
  reviewCartChanged:
    "La sélection a changé. Vérifiez les éléments et acceptez à nouveau les conditions.",
  quoteExpiredCart:
    "Ce devis de promotion a expiré. Sélectionnez à nouveau la promotion depuis votre annonce.",
  chooseAgain: "Choisir à nouveau",
  contextCreateAd: "Prix nouvelle annonce",
  contextMyAds: "Prix depuis Mes annonces",
  paymentOriginal: "Paiement initial",
  viewCart: "Vérifier les services sélectionnés",

  continueToCart: "Continuer vers le paiement groupé",
  bankRateNote:
    "Vous payez en euros. Votre banque applique son propre taux de change.",
  reverseVat: "Autoliquidation de la TVA · paiement unique",
  checkout: "Continuer vers le paiement",
  resumePayment: "Reprendre le paiement",
  storeReceipt: "Voir le reçu de la boutique",
  title: "Donnez plus de visibilité à votre annonce",
  lead: "Choisissez une visibilité payante, une présentation distincte, ou les deux.",
  boost: "Boost",
  boostDetail:
    "Des emplacements sponsorisés tournants dans les recherches pertinentes.",
  highlight: "Highlight",
  highlightDetail:
    "Un cadre vert discret distingue votre annonce, sans changer son classement.",
  bundle: "Se démarquer",
  bundleDetail: "Boost et Highlight pendant sept jours.",
  days: "{{count}} jours",
  preview: "Aperçu de votre annonce",
  previewNote:
    "Une illustration de la présentation, pas une position garantie.",
  choose: "Choisissez une option",
  continue: "Vérifier la promotion",
  notNow: "Pas maintenant",
  total: "Total",
  vat: "TVA incluse · paiement unique",
  saving: "Économisez {{amount}} par rapport aux achats séparés",
  terms:
    "La promotion commence après validation et disponibilité, se suspend en cas d’indisponibilité et se termine à la vente ou au retrait.",
  consent:
    "J’accepte les conditions et demande le début dès que mon annonce est éligible.",
  pay: "Payer {{amount}}",
  paying: "Traitement…",
  error: "Une erreur s’est produite. Veuillez réessayer.",
  retry: "Réessayer",
  unavailable:
    "Les promotions ne sont pas disponibles pour cette annonce actuellement.",
  history: "Vos promotions",
  myAdsCta: "Promotions",
  processingPayment: "Paiement en cours de traitement",
  activeUntil: "Jusqu’au {{date}}",
  endedOn: "Terminée le {{date}}",
  report: "Résultats de la campagne",
  impressions: "Impressions visibles",
  clicks: "Clics",
  ctr: "Taux de clics",
  noData: "Pas encore de données",
  metricsNote:
    "Événements enregistrés pour la campagne, pas des personnes uniques ni des ventes supplémentaires. La moitié de la carte doit être visible une seconde.",
  updated: "Mis à jour le {{date}}",
  start: "Début",
  end: "Fin",
  withdraw: "Retirer la promotion",
  withdrawConfirm: "Arrêter cette promotion ?",
  withdrawNote:
    "La diffusion cesse immédiatement. Tout remboursement est évalué séparément et n’est pas garanti.",
  cancel: "Conserver la promotion",
  confirm: "Arrêter et demander un examen",
  back: "Retour à mes annonces",
  sponsored: "Sponsorisé",
  advertiser: "Payé par {{name}}",
  reason: "Pourquoi cette annonce ?",
  processing:
    "Nous vérifions le paiement sur le serveur. Fermer cette page n’annule pas un paiement terminé.",
  refresh: "Actualiser le statut",
  paymentConfirmed: "Paiement confirmé",
  awaiting_payment: "En attente du paiement",
  awaiting_listing: "En attente de votre annonce",
  active: "Active",
  paused: "En pause",
  completed: "Terminée",
  cancelled: "Annulée",
  refund_required: "Examen nécessaire",
  refunded: "Remboursé",
  refund_requested: "Remboursement demandé",
  pending: "En attente",
  paid: "Payé",
  failed: "Échec",
  payment: "Paiement",
  noCampaign: "Aucune campagne. Votre première promotion apparaîtra ici.",
  viewCampaign: "Voir la campagne",
  checking: "Vérification…",
  expired: "Ce devis a expiré. Actualisez-le avant de payer.",
  noGuarantee: "Aucune garantie de classement, d’impressions ou de vente.",
  previewFixture: "Aperçu local · annonce fictive et exemples · aucun achat",
  daily: "Activité quotidienne (UTC)",
  date: "Date",
  selected: "Sélectionné",
  viewTerms: "Lire les conditions",
  termsTitle: "Conditions de promotion",
  termsBody:
    "Service publicitaire payant unique. Les emplacements sponsorisés tournent parmi les annonces pertinentes ; Highlight modifie uniquement la présentation. La durée compte uniquement pendant l’éligibilité. Un retrait arrête la diffusion et déclenche un examen humain du remboursement. Vos droits légaux restent inchangés.",

  entryTitle: "Aidez les bons acheteurs à découvrir votre pièce",

  entryBody:
    "Choisissez comment votre annonce se distingue, dans les recherches et sur la page d’accueil.",

  entryCta: "Découvrir les options de promotion",

  editorTitle: "Promouvoir votre annonce",

  stepChoose: "Choix",

  stepReview: "Vérification",

  stepPayment: "Paiement",

  boostBenefit: "Gagnez en visibilité",

  highlightBenefit: "Attirez le regard",

  bundleBenefit: "Combinez les deux",

  boostBody: "Emplacements sponsorisés dans les recherches pertinentes.",

  highlightBody:
    "Distinguez votre annonce avec un cadre vert dans les résultats de recherche et les catégories.",

  bundleBody:
    "Visibilité sponsorisée et cadre vert, ensemble pendant sept jours.",

  chooseDuration: "Choisissez la durée",

  previewOriginal: "Votre annonce",

  previewPromoted: "Avec votre promotion",

  selectionHint: "Choisissez une option pour continuer",

  reviewTitle: "Votre promotion en un coup d’œil",

  startsWhenReady: "Commence lorsque votre annonce est validée et disponible",

  pausesWhenNeeded:
    "Se suspend lorsque votre annonce est temporairement indisponible",

  trackResults: "Suivez les impressions et les clics dans Mes annonces",

  close: "Fermer",

  changeOption: "Changer d’option",

  fromPrice: "À partir de {{amount}}",

  placementPreview: "Résultats sponsorisés",

  appearancePreview: "Résultats de recherche",

  previewEmpty: "Découvrez à quoi votre annonce pourrait ressembler",

  oneTime: "Paiement unique",

  reportListing: "Votre annonce",

  viewListing: "Voir l’annonce",

  reportActivity: "Activité de la promotion",

  reportAllTime: "Sur toute la durée de la promotion",

  reportShown: "Affichages",

  reportShownHelp: "Votre annonce mise en avant était visible à l’écran.",

  reportClicksHelp: "Clics sur votre annonce mise en avant.",

  reportRateHelp: "Nombre de clics divisé par les impressions enregistrées.",

  reportChecked: "Rapport consulté le {{date}}",

  reportDaily: "Activité par jour",

  reportPeriod: "Période du rapport",

  reportFullPeriod: "Toute la période",

  reportLastDays: "Les {{count}} derniers jours d’activité",

  reportRecordedDays:
    "Seules les dates avec une activité enregistrée sont affichées. Les jours sont regroupés selon l’heure UTC.",

  reportDataTable: "Voir les chiffres quotidiens",

  reportNoActivity: "Aucune activité enregistrée",

  reportEndedNoActivity:
    "Aucune activité n’a été enregistrée avant l’arrêt de cette promotion.",

  reportNoActivityBody:
    "Les impressions et les clics enregistrés apparaîtront ici. Les totaux ci-dessus indiquent ce qui a été mesuré jusqu’à présent.",

  reportBeforeStart: "Votre rapport commencera avec la diffusion.",

  reportPurchase: "Votre promotion",

  reportIncluded: "Inclus dans cette promotion",

  reportAmount: "Montant de l’achat",

  reportPurchased: "Paiement reçu",

  reportReference: "Référence de la campagne",

  reportScheduledEnd: "Fin prévue",

  reportFinishedOn: "Terminée le",

  reportSupport: "Contacter l’assistance",

  reportRefreshWarning:
    "Nous n’avons pas pu actualiser ce rapport. Les dernières informations disponibles restent affichées.",

  reportPollingStopped:
    "Toujours en attente d’une mise à jour du paiement. Les vérifications automatiques sont suspendues ; actualisez le statut pour vérifier à nouveau.",

  reportResumeBody:
    "Reprenez votre paiement existant. Si vous avez déjà payé, actualisez le statut avant de réessayer.",

  reportPendingBody:
    "Le paiement n’est pas encore confirmé. Vérifiez le paiement initial ou votre boutique d’applications ; vous n’avez pas besoin d’acheter une autre promotion.",

  reportActiveTitle: "Votre promotion est en cours",

  reportActiveBody:
    "Les avantages choisis sont actifs tant que votre annonce est disponible pour les acheteurs.",

  reportWaitingTitle: "Prête dès que votre annonce l’est",

  reportWaitingBody:
    "Le paiement est confirmé. Votre promotion commencera lorsque votre annonce sera validée et disponible. La durée payée n’a pas encore commencé.",

  reportPausedTitle: "Votre promotion est en pause",

  reportPausedBody:
    "Votre annonce est temporairement indisponible. La diffusion reprendra lorsqu’elle sera de nouveau disponible, et le temps de pause sera ajouté à la durée restante.",

  reportHolidayBody:
    "La diffusion est suspendue pendant les vacances de votre boutique. Votre durée payée est préservée jusqu’à ce que votre annonce soit de nouveau disponible.",

  reportReservedBody:
    "Votre annonce est réservée. La diffusion est suspendue pendant la réservation ; votre durée payée est préservée.",

  reportVerificationBody:
    "Nous vérifions votre achat auprès de la boutique d’applications. La diffusion est suspendue et votre durée payée est préservée. Il n’est pas nécessaire d’acheter à nouveau.",

  reportPlatformPauseBody:
    "Nous avons temporairement suspendu la diffusion des promotions. Votre durée payée est préservée ; vous n’avez rien à faire.",

  reportApprovalBody:
    "Votre annonce est en cours de vérification. La diffusion commencera ou reprendra lorsqu’elle sera validée et disponible ; l’attente ne réduit pas la durée de votre promotion.",

  reportFinishedTitle: "Votre promotion est terminée",

  reportFinishedBody:
    "La période de diffusion achetée est terminée. Le rapport ci-dessous présente l’activité enregistrée pendant votre promotion.",

  reportSoldBody:
    "Votre article a été vendu, la diffusion de la promotion a donc pris fin. L’activité ci-dessous correspond à la diffusion enregistrée et ne prouve pas que la promotion a entraîné la vente.",

  reportWithdrawnBody:
    "Votre annonce n’est plus disponible, la diffusion de la promotion s’est donc arrêtée.",

  reportStoppedTitle: "La diffusion de la promotion est arrêtée",

  reportStoppedBody:
    "Cette promotion n’est plus diffusée. L’activité enregistrée et les détails de votre achat restent disponibles ci-dessous.",

  reportReviewTitle: "Votre promotion nécessite un examen",

  reportReviewBody:
    "La diffusion est arrêtée pendant l’examen de cet achat. Contactez l’assistance si vous avez besoin d’aide ; aucun remboursement n’a été confirmé.",

  reportWithdrawalBody:
    "Votre demande a été reçue et la diffusion est arrêtée. Tout remboursement sera évalué séparément.",

  reportRefundedTitle: "Paiement remboursé",

  reportRefundedBody:
    "Un remboursement a été confirmé et cette promotion n’est plus diffusée.",

  reportNotFound: "Nous n’avons pas trouvé cette promotion dans votre compte.",

  reportWithdrawalFailed:
    "Nous n’avons pas pu confirmer votre demande. Cette fenêtre reste ouverte pour vous permettre de réessayer. En cas de doute, vérifiez le statut de la campagne.",

  reportRequestReview: "Demander un examen",

  reportReviewConfirm: "Demander un examen de cette promotion ?",

  reportReviewNote:
    "La diffusion est déjà terminée. Nous évaluerons votre demande séparément ; cela ne garantit pas un remboursement.",

  reportConfirmReview: "Envoyer la demande d’examen",
  customPromotion: "Votre promotion",
  border: "Cadre",
  label: "Étiquette",
  homepage: "Place en page d’accueil",
  fullBundle: "Pack visibilité",
  selectBundle: "Choisir Stand out",
  bundleIncludes: "Boost, Cadre et Étiquette pendant 7 jours",
  bundleSaving: "Économisez {{amount}} par rapport aux achats séparés",
  bundleRecommendation:
    "Profitez de 7 jours de Boost, Cadre et Étiquette pour {{amount}} — moins cher que cette sélection.",
  borderBody: "Un cadre vert autour de votre carte.",
  labelBody: "Votre étiquette choisie en tant que vendeur.",
  homepageBody: "Cartes sponsorisées en rotation sur l’accueil.",
  homepageTerms:
    "Une place en rotation, pas une position exclusive. Aucune garantie d’affichage ou de vente.",
  homepageHeading: "Découvrez davantage",
  homepageContext: "Sur la page d’accueil",
  homepagePreviewNote:
    "Votre carte rejoint une sélection sponsorisée en rotation. Cet aperçu ne promet aucune position fixe.",
  labelChoose: "Choisir une étiquette",
  labelMustGo: "Doit partir",
  labelMovingSale: "Vente pour déménagement",
  labelInvoice: "Avec facture d’origine",
  labelCollect: "Prêt à être retiré",
  labelAttestation:
    "Je confirme que cette étiquette est exacte pour mon annonce.",
  labelPaidNote:
    "Choisie et payée par le vendeur. Il ne s’agit pas d’une vérification par Whoppah.",
  labelRequired:
    "Choisissez une étiquette et confirmez son exactitude avant de continuer.",
  none: "Aucun",
  addBenefit: "Ajouter {{benefit}}",
  removeBenefit: "Retirer {{benefit}}",
  selectionUnavailable:
    "Cette sélection est actuellement indisponible. Modifiez vos choix ou vérifiez à nouveau la disponibilité.",
  effectUnavailable: "Déjà actif ou indisponible pour cette annonce",
  homepageSoldOut:
    "Les places en page d’accueil sont actuellement complètes. Choisissez d’autres avantages ou réessayez plus tard.",
  checkAvailability: "Vérifier la disponibilité",
  mixedDurationNote:
    "Chaque avantage a sa propre durée. La place en page d’accueil prend fin après 3 jours ; les avantages plus longs continuent.",
  selectedBenefits: "Vos avantages sélectionnés",
  benefitStatus: "État de chaque avantage",
  placementsTitle: "Où votre promotion est apparue",
  placementSearch: "Résultats de recherche",
  placementCategory: "Résultats de catégorie",
  placementCard: "Cadre et étiquette sur les cartes",
  placementHomepage: "Page d’accueil",
  placementLegacyHighlight: "Cartes mises en évidence",
  placementOther: "Autre emplacement",
  sharedExposureNote:
    "Une carte peut inclure des avantages de plusieurs achats. Les totaux comptent les affichages enregistrés, pas une audience unique.",
  homepageCapacityWait:
    "Votre paiement est confirmé. La promotion commencera lorsqu’une place en page d’accueil et votre annonce seront disponibles. Votre durée payée n’a pas commencé.",
  labelSuppressed:
    "Cette étiquette a été arrêtée pour examen. Contactez l’assistance pour obtenir de l’aide avec votre achat.",
  newBenefits: "Ajouter d’autres avantages de promotion",
  previewSearch: "Carte de recherche et de catégorie",
  previewHome: "Carte de page d’accueil",
  benefitEnd: "Fin prévue de l’avantage",
  benefitStarts: "Début de l’avantage",
  historicalBundle: "Boost et Highlight",
  bundleV2Body:
    "Boost, un cadre vert et votre étiquette, ensemble pendant 7 jours.",
  customPromotionBody: "Vos avantages de promotion sélectionnés.",
  customPromotionBenefit: "Choisissez vos avantages",
  placementPartial:
    "Les détails de placement manquent pour une partie de l’activité enregistrée. Cette activité reste incluse dans les totaux de votre campagne.",
  reportSomeActiveBody:
    "Au moins un avantage est actif. Consultez ci-dessous l’état et les dates propres à chaque avantage.",
  homepageWaitReview:
    "Aucune place en page d’accueil ne s’est libérée pendant le délai d’attente. Cet achat nécessite un examen de remboursement ; aucun remboursement n’est encore confirmé.",
  chooseBenefits: "Composez votre promotion",
  selectionBenefitsHint: "Choisissez une ou plusieurs options",
  termsBodyV2:
    "Il s’agit d’un service publicitaire payant, sans renouvellement automatique. Les places sur la page d’accueil tournent. Cadre et Étiquette modifient l’apparence de la carte ; les étiquettes sont choisies et confirmées par le vendeur, sans vérification de Whoppah. Chaque option dure le temps acheté tant que l’annonce est éligible. Un achat incluant une place sur la page d’accueil commence lorsqu’une place et l’annonce sont disponibles. Le retrait arrête la diffusion et déclenche un examen humain du remboursement. Vos droits légaux restent inchangés.",
  homepageStartFact:
    "Commence quand votre annonce et une place sur la page d’accueil sont disponibles",
  salesEyebrow: "METTEZ-LE EN VALEUR",
  salesTitle: "Le beau design mérite d’être vu.",
  salesBody: "Choisissez un pack ou composez le vôtre.",
  offerBoostBody:
    "Touchez les acheteurs qui recherchent des objets comme le vôtre.",
  offerBundleBody:
    "Plus de visibilité. Un style distinctif. Le tout dans un seul pack.",
  offerHomeTitle: "Stand out + page d’accueil",
  offerHomeBody:
    "Démarquez-vous dans les recherches et attirez les regards sur la page d’accueil.",
  offerBoostCta: "Choisir Boost",
  offerHomeCta: "Choisir le pack",
  offerAllTogether: "Visibilité + style",
  offerWiderReach: "Recherche + page d’accueil",
  offerSearchReach: "Visibilité dans les recherches",
  offerRecommended: "Notre choix",
  offerMixedDuration: "Stand out 7 jours · Accueil 3 jours",
  offerSearchBenefit:
    "Emplacements sponsorisés dans les recherches pertinentes",
  offerStyleBenefit: "Cadre vert + étiquette vendeur",
  offerResultsBenefit: "Suivez les impressions et les clics dans Mes annonces",
  offerBundleBenefit: "Boost + Cadre + Étiquette",
  offerHomeBenefit: "Emplacement tournant sur l’accueil",
  offerSelected: "Sélectionné",
  offerCustomize: "Choisir des options individuelles",
  offerMakeYours: "Votre aperçu",
  offerPreviewBody: "Vérifiez votre choix avant de payer.",
  completionOptional:
    "La promotion est facultative. Vous pouvez aussi choisir plus tard dans Mes annonces.",
  individualOptionsBody: "Choisissez une option ou combinez.",
  individualLink: "Voir les options individuelles",
  standOutTitle: "Faites ressortir votre annonce",
  standOutLead:
    "Choisissez une ou plusieurs options. Commence dès que votre annonce est en ligne et disponible.",
  packDetail: "Boost de 7 jours, cadre et étiquette réunis.",
  bestValue: "Meilleur prix",
  percentOff: "{{percent}}% de réduction",
  orSeparately: "ou choisissez séparément",
  boostPickerDetail:
    "Votre annonce remonte en tête de sa catégorie. Démarre dès que votre annonce est en ligne.",
  boostRunning:
    "Un boost est déjà en cours pour cette annonce. Vous pourrez ajouter un nouveau boost une fois qu’il sera terminé.",
  framePickerDetail:
    "Un cadre vert autour de votre annonce dans les résultats, pendant 7 jours.",
  labelMustGoTitle: "Étiquette « Doit partir »",
  previousPaymentProcessing:
    "Votre paiement précédent est encore en cours de traitement. Réessayez dans une minute.",
  labelPickerDetail: "Une courte étiquette sur votre annonce pendant 7 jours.",
  homepagePickerDetail:
    "Une place sponsorisée en rotation sur la page d’accueil pendant 3 jours.",
  searchPreviewTitle: "Votre annonce dans les résultats de recherche",
  searchPreviewLead:
    "Votre annonce, avec des cases grises pour les annonces voisines.",
  promotedTab: "Sponsorisé",
  boostSummary: "Boost de {{count}} jours",
  labelSummary: "Étiquette « {{text}} »",
  nothingSelected: "Aucune sélection",
  continueWithPrice: "Continuer vers le paiement · {{price}}",
  goToMyAds: "Voir mes annonces",
  pricingContextChanged:
    "La remise pour une nouvelle annonce n’est plus disponible. Les prix ont été actualisés.",
} as const;
